import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = () => {
    if (username === 'admin' && password === '1234') {
      navigate('/dashboard');
    } else {
      alert('Invalid username or password!');
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#c5baaa]">
      <div className="w-full max-w-md p-8 bg-[#2c2c2c] rounded-2xl shadow-lg">
        <h2 className="text-2xl font-bold text-center text-[#ee7828] mb-6">Admin Login</h2>
        <div className="mb-4">
          <label className="block text-[#806d61] mb-2" htmlFor="username">
            Username
          </label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full px-4 py-2 border rounded-lg bg-[#c5baaa] text-[#2c2c2c] focus:outline-none focus:ring-2 focus:ring-[#ee7828]"
            placeholder="Enter your username"
          />
        </div>
        <div className="mb-6">
          <label className="block text-[#806d61] mb-2" htmlFor="password">
            Password
          </label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-2 border rounded-lg bg-[#c5baaa] text-[#2c2c2c] focus:outline-none focus:ring-2 focus:ring-[#ee7828]"
            placeholder="Enter your password"
          />
        </div>
        <button
          onClick={handleLogin}
          className="w-full py-2 px-4 bg-[#ee7828] text-white rounded-lg hover:bg-[#d46922] transition duration-300"
        >
          Login
        </button>
      </div>
    </div>
  );
};

export default AdminLogin;
